/**
 * <faq-ask>: the "Ask a question" row under the FAQ, rendered by blocks/faq-ask.liquid.
 * Clicking it opens the Shopify Inbox chat. Read that block's doc comment before turning it
 * back into a real text field: the typed text cannot reach the chat's box.
 */

const CHAT_READY_TIMEOUT_MS = 2000;

class FaqAsk extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.#onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#onSubmit);
  }

  #onSubmit = (event) => {
    event.preventDefault();
    openChat(event.target.action);
  };
}

/**
 * Opens the chat via <shopify-chat>.show(), which moves focus into the chat's own box. The
 * method is public on the element but undocumented (it mirrors the documented
 * <shopify-cart>.show()). Its module loads async, so an early click waits briefly for the
 * element to upgrade. If the chat is missing (app embed off, script blocked) or never becomes
 * ready, the form's own target, the contact page, takes over.
 */
async function openChat(fallbackUrl) {
  const chat = document.querySelector('shopify-chat');

  if (chat) {
    try {
      await Promise.race([
        customElements.whenDefined('shopify-chat'),
        new Promise((_, reject) => setTimeout(reject, CHAT_READY_TIMEOUT_MS)),
      ]);
      if (typeof chat.show === 'function') {
        chat.show();
        return;
      }
    } catch {
      // Not ready in time: fall through to the contact page.
    }
  }

  if (fallbackUrl) window.location.assign(fallbackUrl);
}

if (!customElements.get('faq-ask')) customElements.define('faq-ask', FaqAsk);
